import type { GamefeedRawData } from 'bam-node-evp/src/schema/types.ts'

// Same idea as `canBePersonalized` in evp
export default function canBePersonalized(data: GamefeedRawData[]) {
    // Need to find the strike zone data and all be equivalent to be personalized
    if (!data.length) {
        return false
    }

    const { sz_bot, sz_depth, sz_top, sz_width } = data[0]

    if (
        sz_bot === undefined ||
        sz_top === undefined ||
        sz_top === null ||
        sz_bot === null
    ) {
        return false
    }

    return data.every(
        (d) =>
            d.sz_bot === sz_bot &&
            d.sz_top === sz_top &&
            d.sz_width === sz_width &&
            d.sz_depth === sz_depth
    )
}
